import script from "./Campus.vue?vue&type=script&setup=true&lang=js"
export * from "./Campus.vue?vue&type=script&setup=true&lang=js"

import "./Campus.vue?vue&type=style&index=0&id=399685a7&lang=css"

const __exports__ = script;

export default __exports__